
export default class Radio {
    screenSaverTimeout: number = 30;
    enableCategories: boolean = false;
}